import { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { hexToRgba, isColorDark, resolveLinkProps } from '../utils';
import { getButtonIcon, resolveIconKey } from '../buttonIcons';

export default function StickyBarSection({ block = {}, brand, primaryColor, isPreview }) {
    const { config = {}, content = {} } = block;
    const [dismissed, setDismissed] = useState(false);
    const position = config.position || 'top';
    const accent = config.accent_color || primaryColor;
    const bg = config.bg_color || accent;
    const textColor = config.text_color || '#ffffff';

    const sectionButtons = content.buttons && content.buttons.length > 0
        ? content.buttons
        : content.cta_text ? [{ text: content.cta_text, link: content.cta_link || '#', style: 'solid', icon: '', bg_color: '', text_color: '' }] : [];

    if (!content.text) return null;

    return (
        <AnimatePresence>
        {(!dismissed || isPreview) && (
        <motion.div
            initial={{ y: position === 'top' ? -100 : 100 }}
            animate={{ y: 0 }}
            exit={{ y: position === 'top' ? -100 : 100 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className={`${isPreview ? 'relative w-full' : `fixed left-0 right-0 z-[9999] ${position === 'top' ? 'top-0' : 'bottom-0'}`}`}
            style={{ backgroundColor: bg }}
        >
            <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
                <p className="text-sm font-medium flex-1 text-center" style={{ color: textColor }}>
                    {content.text}
                </p>
                {sectionButtons.map((btn, i) => {
                    const btnStyle = btn.style || 'solid';
                    const icon = btn.icon && getButtonIcon(resolveIconKey(btn.icon));
                    const lp = resolveLinkProps(btn.link || '#');
                    const customBg = btn.bg_color;
                    const customText = btn.text_color;
                    let cls = 'shrink-0 px-4 py-1.5 rounded-full text-xs font-semibold transition-all hover:opacity-90 inline-flex items-center gap-1.5 ';
                    let style = {};
                    if (btnStyle === 'solid' || btnStyle === 'pill') {
                        if (customBg) { style.backgroundColor = customBg; style.color = customText || (isColorDark(customBg) ? '#fff' : '#111'); }
                        else { style.backgroundColor = textColor; style.color = bg; }
                    } else if (btnStyle === 'outline') {
                        if (customBg) { style.color = customBg; style.borderColor = customBg; cls += 'border'; }
                        else { style.color = textColor; style.borderColor = textColor; cls += 'border'; }
                    } else { style.color = customText || textColor; }
                    if (customText && (btnStyle === 'solid' || btnStyle === 'pill')) style.color = customText;
                    return <a key={i} {...lp} className={cls} style={style}>{icon}{btn.text}</a>;
                })}
                <button
                    onClick={() => setDismissed(true)}
                    aria-label="Cerrar"
                    className="shrink-0 p-1 rounded-full transition-colors hover:bg-white/20"
                    style={{ color: textColor }}
                >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </motion.div>
        )}
        </AnimatePresence>
    );
}
